/* tslint:disable */
/* eslint-disable */
export enum InsurerPreHospiAllowContinueEnum {
  None = 'NONE',
  Block = 'BLOCK',
  Warn = 'WARN'
}
